"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = {
  'inputForm.instruction': 'Tous les champs sont obligatoires sauf s\'ils sont marqués comme facultatifs',
  'inputField.label.firstName': 'Prénom',
  'inputField.label.lastName': 'Nom de famille',
  'inputField.label.fullName': 'Nom sur la carte',
  'inputField.label.Email': 'E-mail',
  'inputField.label.phoneNumber': 'Numéro de téléphone',
  'inputField.placeholder.firstName': 'John',
  'inputField.placeholder.lastName': 'Doe',
  'inputField.placeholder.fullName': 'John Doe',
  'inputField.placeholder.email': 'john.doe@cashstar.com',
  'inputField.placeholder.phoneNumber': 'Entrez le numéro de téléphone',
  'inputField.errorMessage.incompleteField': 'Champ incomplet',
  'inputField.errorMessage.exceedsMaxCharacters': 'Dépasse {max} caractères',
  'inputField.errorMessage.pleaseEnterAValidFirstName': 'Veuillez entrer un prénom valide',
  'inputField.errorMessage.pleaseEnterAValidLastName': 'Merci d\'entrer un nom de famille valide',
  'inputField.errorMessage.pleaseEnterAValidFullName': 'Veuillez entrer un nom complet valide',
  'inputField.errorMessage.invalidAddressValue': 'S\'il-vous-plaît entrez une adresse valide',
  'inputField.errorMessage.invalidCityValue': 'SVP, saisir le nom d\'une ville qui existe',
  'inputField.errorMessage.pleaseEnterAValidEmailAddress': 'S\'il vous plaît, mettez une adresse email valide',
  'inputField.errorMessage.pleaseEnterAValidPhoneNumber': 's\'il vous plaît entrer un numéro de téléphone valide',
  'inputField.errorMessage.invalidName': 'Merci d\'entrer un nom valide',
  'header.text.billingInfo': 'Détails de facturation',
  'submitButton.adyen.label': 'Payez maintenant',
  'inputField.label.cardNumber': 'Numéro de carte',
  'inputField.label.cardExpiry': 'Date d\'expiration (MM/YY)',
  'inputField.label.cardCVV': 'CVV/CVC',
  'inputField.placeholder.cardNumber': 'Numéro de carte',
  'inputField.placeholder.cardExpiry': 'MM/YY',
  'inputField.placeholder.cardCVV': '3 ou 4 chiffres',
  'inputField.errorMessage.invalidCardNumber': 'S\'il vous plaît entrez un numéro de carte valide',
  'inputField.errorMessage.cardTypeNotSupported': "Le type de carte n'est pas pris en charge",
  'inputField.errorMessage.invalidCardExpiry': 'Veuillez entrer une date d\'expiration valide',
  'inputField.errorMessage.invalidCardCVV': 'Veuillez entrer un CVV ou un CVC valide',
  'inputField.label.saveCardLabel': 'Garder pour plus tard',
  'inputField.label.makeAsDefaultLabel': 'Marquer par défaut',
  'paymentMethod.paypal.login.initial': 'Pour finaliser le paiement via PayPal, veuillez vous connecter et valider les informations de paiement',
  'paymentMethod.paypal.login.success': 'Validation réussie, veuillez terminer la commande',
  'paymentMethod.zipPay.minCartAmount': 'La valeur minimale de commande pour utiliser Zip est de 35 $',
  'paymentMethod.zipPay.additionalCharges': 'Des frais marchands supplémentaires jusqu\'à {amount} peuvent s\'appliquer au total de votre commande pour utiliser Zip.',
  'paymentMethod.adyen.label': 'Carte de crédit/débit et e-banking',
  'paymentMethod.adyen.single.label': 'Carte de crédit / débit',
  'paymentMethod.paypal.label': 'PayPal',
  'paymentMethod.zippay.label': 'Zip',
  'paymentMethod.creditCard.label': 'Carte de crédit / débit',
  'paymentMethod.googlePay.label': 'Google Pay',
  'paymentMethod.applePay.label': 'Apple Pay',
  "inputField.label.country": "Pays",
  "inputField.label.zipcode": "Code postal",
  "inputField.label.addressLine": "Ligne d'adresse 1",
  "inputField.label.addressLineTwo": "Ligne d'adresse 2 (en option)",
  "inputField.label.city": "Ciudad",
  "inputField.label.state": "État",
  "inputField.placeholder.zipCode": "Code postal",
  "inputField.placeholder.addressLine": "Ligne d'adresse 1",
  "inputField.placeholder.addressLineTwo": "Ligne d'adresse 2 (en option)",
  "inputField.placeholder.city": "Ciudad",
  "inputField.placeholder.state": "État"
};
exports.default = _default;